import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    width: '100%',
    borderRadius: 24,
    boxShadow: '0px 4px 14px rgba(151, 149, 149, 0.04)',
    transition: '0.2s ease-in-out',

    [theme.breakpoints.between('sm', 'lg')]: {
      maxWidth: 680
    }
  },
  cardActionArea: {
    height: '100%'
  },
  cardContent: {
    minHeight: 190,
    padding: 32,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      padding: 24
    }
  },
  category: {
    width: 'fit-content',
    padding: '6px 14px',
    borderRadius: 999,
    marginBottom: 24,
    fontSize: 12,
    fontWeight: 600
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    lineHeight: 1.4,

    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 0,
    marginTop: 32
  },
  actionsButton: {
    padding: 0,
    minWidth: 'fit-content',
    textTransform: 'none',

    '&:hover': {
      background: 'transparent'
    }
  },
  actionText: {
    fontSize: 14,
    fontWeight: 400
  }
}))
